export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SideBar.vue?vue&type=template&id=6f22d6b8&"


//////////////////
// WEBPACK FOOTER
// ./src/components/side-bar/SideBar.vue?vue&type=template&id=6f22d6b8&
// module id = 896
// module chunks = 0